import { useAppStore } from '@/shared/store/app.store.ts'
import SessionService from '../../data/session.service.ts'
import { mapSessionDtoToSession } from '../mappers/session.mapper.ts'
import { mapProjectDtoToProject } from '../mappers/project.mapper.ts'
import type { Session } from '@/features/session/domain/models/session.ts'

const getProjectId = async (projectId?: string): Promise<string> => {
  if (projectId) return projectId
  const user = await SessionService.getCurrentUser()
  const projects = await SessionService.getProjects()
  const userProjectName = `${user.firstName}'s Project`
  const userProject = projects.find(
    (project) => project.projectName === userProjectName
  )

  const { setProject } = useAppStore.getState()

  if (userProject) {
    setProject(mapProjectDtoToProject(userProject))
    return userProject.projectId
  }

  return await createProject(userProjectName)
}

export const createSession = async (
  audioformId?: string,
  existingProjectId?: string,
  state: Record<string, unknown> = {}
): Promise<Session> => {
  const { setSession } = useAppStore.getState()

  const projectId = await getProjectId(existingProjectId)

  const sessionDto = await SessionService.createSession(
    projectId,
    'pro-session',
    audioformId,
    state
  )
  const session = mapSessionDtoToSession(sessionDto)
  setSession(session)

  return session
}

const createProject = async (projectName: string): Promise<string> => {
  const { setProject } = useAppStore.getState()

  const project = await SessionService.createProject(projectName)
  setProject(mapProjectDtoToProject(project))
  return project.projectId
}
